import React from "react";
import {ReactNode} from 'react';
import "../assets/landing.css"
import {useEffect} from 'react'

export default function FeedbackPage({...props}) {
    return (
      <div>
        <div className="top-banner-container" id="team">
          <div className="first-section-meet-team-sec"> 
            <div className="first-section-meet-team-con">
                <h1><strong>YOUR OPINION MATTERS</strong><br/> 
                Fill the Google Form below and leave any comment.</h1>
            </div>
          </div>
        </div>
          <section className="snd_section">
            <div className="snd_s_con" style={{display:"flex"}}>
              <div className="snd_s_fb">  
                <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfOq7Qe8WitT9CzC8WFJzkQGoFKRBAyI-ZCfzpFgJNxGQQ-wQ/viewform?embedded=true" frameBorder="0" marginHeight={0} marginWidth={0} width={640} height={1162}>Cargando…</iframe>
              </div>
            </div>
          </section>
      </div>
      );
  }